import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-stepper.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-stepper.component.css?ngResource";
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { CalciteStepperService } from "./calcite-stepper.service";
export let CalciteStepperComponent = class CalciteStepperComponent {
    calciteStepperService;
    changeDetectorRef;
    calciteStepper;
    onStepClicked = new EventEmitter();
    options = [];
    scale = "m" /* CalciteStepperScale.medium */;
    icon = "" /* CalciteStepperIcon.noIcon */;
    numbered = "" /* CalciteStepperNumbered.no_numbers */;
    stepperHtmlElement;
    constructor(calciteStepperService, changeDetectorRef) {
        this.calciteStepperService = calciteStepperService;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.stepperHtmlElement = document.getElementById("calciteStepper");
        this.calciteStepperService.setStepOptions(this.options);
        this.calciteStepperService.totalSteps = this.options.length;
        this.calciteStepperService.stepOptionsAsObservable.subscribe((options) => {
            this.options = options;
            this.setItemValues(options);
            this.changeDetectorRef.detectChanges();
        });
    }
    setItemValues(options) {
        if (this.stepperHtmlElement) {
            let index = -1;
            // clear the current nodes
            this.stepperHtmlElement.innerHTML = "";
            this.stepperHtmlElement.setAttribute("numbered", this.numbered === "numbered" /* CalciteStepperNumbered.numbered */ ? "true" : "false");
            this.stepperHtmlElement.setAttribute("icon", this.icon === "icon" /* CalciteStepperIcon.icon */ ? "true" : "false");
            this.stepperHtmlElement.setAttribute("scale", `${this.scale}`);
            options.forEach((option) => {
                index++;
                option.stepIndex = index;
                const step = document.createElement("calcite-stepper-item");
                step.setAttribute("id", option.stepId);
                step.setAttribute("item-title", option.stepTitle);
                step.setAttribute("item-subtitle", option.stepSubtitle);
                step.innerText = option.stepContent;
                switch (option.stepType) {
                    case "active" /* CalciteStepperItemType.active */:
                        step.setAttribute("active", "true");
                        break;
                    case "disabled" /* CalciteStepperItemType.disabled */:
                        step.setAttribute("disabled", "true");
                        break;
                    case "complete" /* CalciteStepperItemType.complete */:
                        step.setAttribute("complete", "true");
                        break;
                    case "error" /* CalciteStepperItemType.error */:
                        step.setAttribute("error", "true");
                        break;
                }
                step.addEventListener("click", () => {
                    onClick(option.stepId);
                });
                this.stepperHtmlElement?.appendChild(step);
                const onClick = (stepId) => {
                    this.onStepClicked.emit(stepId);
                };
            });
        }
    }
    static ctorParameters = () => [
        { type: CalciteStepperService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        calciteStepper: [{ type: ViewChild, args: ["calciteStepper", { static: false },] }],
        onStepClicked: [{ type: Output, args: ["onStepClicked",] }],
        options: [{ type: Input }],
        scale: [{ type: Input }],
        icon: [{ type: Input }],
        numbered: [{ type: Input }]
    };
};
CalciteStepperComponent = __decorate([
    Component({
        selector: "lib-calcite-stepper",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteStepperComponent);
